import { useTranslation } from "react-i18next";
const DilemmaCreatePageHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.dilemmas.create")}</h1>
    </div>
  );
};

export default DilemmaCreatePageHeader;
